import "@styles/globals.css";
import "@styles/prism.css";
import "katex/dist/katex.css";

import siteMetadata from "@/data/siteMetadata";
import { ClientReload } from "@components/blog/ClientReload";
import SegmentIntegration from "components/SegmentIntegration";
import { ThemeProvider } from "next-themes";
import Head from "next/head";
import { useEffect } from "react";
import TagManager from "react-gtm-module";
import { Toaster } from "react-hot-toast";
import { useAnalytics } from "services/analytics.service";
import { Analytics } from "@vercel/analytics/react";
import { AnalyticsContextProvider } from "context/AnalyticsContext";

const isDevelopment = process.env.NODE_ENV === "development";
const isSocket = process.env.SOCKET;

export default function Website({
  Component,
  pageProps,
}: NextPageTypes.AppPropsWithLayout) {
  useAnalytics();
  useEffect(() => {
    TagManager.initialize({
      gtmId: process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER as string,
    });
  }, []);
  const getLayout = Component.getLayout || ((page) => page);
  return (
    <AnalyticsContextProvider>
      <ThemeProvider attribute="class" defaultTheme={siteMetadata.theme}>
        <Head>
          <meta content="width=device-width, initial-scale=1" name="viewport" />
        </Head>

        <SegmentIntegration />
        {isDevelopment && isSocket && <ClientReload />}
        {getLayout(<Component {...pageProps} />)}
        <Toaster position="bottom-right" />
        <Analytics />
      </ThemeProvider>
    </AnalyticsContextProvider>
  );
}
